var DateRangePickerModule = (function () {
    function DateRangePickerModule() {
    }
    return DateRangePickerModule;
}());
export { DateRangePickerModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/date-range-picker/date-range-picker.module.ts.pre-build-optimizer.js